/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreatePersonnelFileCategoryDto } from '../models/work-create-personnel-file-category-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPersonnelFileCategory } from '../models/work-personnel-file-category';
import { WorkUpdatePersonnelFileCategoryDto } from '../models/work-update-personnel-file-category-dto';

@Injectable({ providedIn: 'root' })
export class WorkPersonnelFileCategoriesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `personnelFileCategoriesV2ControllerFindAll()` */
  static readonly PersonnelFileCategoriesV2ControllerFindAllPath = '/v2/personnel-file-categories';

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFileCategoriesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFileCategoriesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkPersonnelFileCategory>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFileCategoriesV2Service.PersonnelFileCategoriesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkPersonnelFileCategory>>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFileCategoriesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFileCategoriesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkPersonnelFileCategory>> {
    return this.personnelFileCategoriesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkPersonnelFileCategory>>): Array<WorkPersonnelFileCategory> => r.body)
    );
  }

  /** Path part for operation `personnelFileCategoriesV2ControllerCreate()` */
  static readonly PersonnelFileCategoriesV2ControllerCreatePath = '/v2/personnel-file-categories';

  /**
   * Required permissions: personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFileCategoriesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnelFileCategoriesV2ControllerCreate$Response(
    params: {
      body: WorkCreatePersonnelFileCategoryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPersonnelFileCategory>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFileCategoriesV2Service.PersonnelFileCategoriesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPersonnelFileCategory>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFileCategoriesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnelFileCategoriesV2ControllerCreate(
    params: {
      body: WorkCreatePersonnelFileCategoryDto
    },
    context?: HttpContext
  ): Observable<WorkPersonnelFileCategory> {
    return this.personnelFileCategoriesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPersonnelFileCategory>): WorkPersonnelFileCategory => r.body)
    );
  }

  /** Path part for operation `personnelFileCategoriesV2ControllerGetDropdownOptions()` */
  static readonly PersonnelFileCategoriesV2ControllerGetDropdownOptionsPath = '/v2/personnel-file-categories/dropdown-options';

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFileCategoriesV2ControllerGetDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFileCategoriesV2ControllerGetDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFileCategoriesV2Service.PersonnelFileCategoriesV2ControllerGetDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFileCategoriesV2ControllerGetDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFileCategoriesV2ControllerGetDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.personnelFileCategoriesV2ControllerGetDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `personnelFileCategoriesV2ControllerFindOneById()` */
  static readonly PersonnelFileCategoriesV2ControllerFindOneByIdPath = '/v2/personnel-file-categories/{id}';

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFileCategoriesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFileCategoriesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPersonnelFileCategory>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFileCategoriesV2Service.PersonnelFileCategoriesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPersonnelFileCategory>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFileCategoriesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFileCategoriesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkPersonnelFileCategory> {
    return this.personnelFileCategoriesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPersonnelFileCategory>): WorkPersonnelFileCategory => r.body)
    );
  }

  /** Path part for operation `personnelFileCategoriesV2ControllerSoftDelete()` */
  static readonly PersonnelFileCategoriesV2ControllerSoftDeletePath = '/v2/personnel-file-categories/{id}';

  /**
   * Required permissions: personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFileCategoriesV2ControllerSoftDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFileCategoriesV2ControllerSoftDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFileCategoriesV2Service.PersonnelFileCategoriesV2ControllerSoftDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFileCategoriesV2ControllerSoftDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFileCategoriesV2ControllerSoftDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.personnelFileCategoriesV2ControllerSoftDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `personnelFileCategoriesV2ControllerUpdate()` */
  static readonly PersonnelFileCategoriesV2ControllerUpdatePath = '/v2/personnel-file-categories/{id}';

  /**
   * Required permissions: personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFileCategoriesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnelFileCategoriesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdatePersonnelFileCategoryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFileCategoriesV2Service.PersonnelFileCategoriesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFileCategoriesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnelFileCategoriesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdatePersonnelFileCategoryDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.personnelFileCategoriesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
